import { useLocalStorage } from "@/composables";

export const AuthorizedGuard = () => {
  const tokenStorage = useLocalStorage("tms_token");
  if (tokenStorage.get() === null) {
    return { name: "login" };
  }
  return true;
};
